import React from 'react';
import styled from 'styled-components';
import { Link, useLocation } from 'react-router-dom';
import blankBg from 'images/blank.jpg';
import { useTranslation } from 'react-i18next';

const Container = styled.div`
	position: relative;
	background-image: url(${props => props.$bg});
	background-repeat: no-repeat;
	background-size: cover;
	background-position: center;
	padding: 0px 0;
	@media (min-width: 980px) { padding: 0px 0 40px 0; }
	
	&:before {
		content: '';
		background-color: rgba(3, 71, 129, 0.6);
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		z-index: 10;
	}

	h1, p {
		z-index: 20;
	}
	
	> div {
		height: 40px;
		background-color: #B3C8D9;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
		font-size: 14px;
		line-height: 17px;
		color: #034781;
		position: absolute;
		bottom: 0;
		width: 100%;
		z-index: 11;
		@media (max-width: 979px) { display: none; }
		
		a {
			text-decoration: none;
			font-size: 14px;
			line-height: 17px;
			color: #034781;
			margin: 0 5px;
			
			&:last-child {
				color: #0270CB;
			}
			
			&:hover {
				color: #0270CB;
			}
		}
		
		a.upper {
			text-transform: uppercase;
		}
	}
`;

export const Banner = ({ method = '' }) => {
	const location = useLocation();
	const { t } = useTranslation();
	//console.log(props);

	const breadcrumbs = location.pathname.split('/').map(i => {

		if (i === method) {
			if (String(method).length > 0) {
				return {label: t('МЕТОД') + ' ' + method, class: ''};
			}
		}

		switch (i) {
		case '': return { link: '/', label: t('Главная'), class: 'upper' };
		case 'hotel_integration': return { link: '/hotel_integration', label: t('Интеграция с отелями'), class: 'upper' };
		case 'buyer_integration': return { link: '/buyer_integration', label: t('Интеграция с покупателями'), class: 'upper' };
		case 'method': return { link: '/buyer_integration', label: t('Интеграция с покупателями'), class: 'upper' };
		case 'between_systems': return { link: '/buyer_integration/between_systems', label: t('Взаимодействие между системами'), class: 'upper' };
		case 'error404': return { link: '/error404', label: t('404 — Страница не найдена'), cover: blankBg };
		default: return { link: '/', label: '? ? ?', class: '' };
		}
	});

	return (
		<Container className='block-fullwidth flex column align-stretch' $bg={breadcrumbs.slice(-1)[0].cover}>
			{breadcrumbs.length > 0 && <div>
				{breadcrumbs.map((b, key) => <Link key={key} className={b.class} to={b.link}>{b.label}</Link>).reduce((prev, curr) => [prev, '>', curr])}
			</div>}
		</Container>
	);
};